import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    rewards: 'Total Rewards',
    stakers: 'Stakers',
    apy: 'APY',
    epoch: 'Epoch',
    apyTooltipText:
      'APY is calculated based on the 90-day moving average of the stIOTA-to-IOTA exchange rate.',
  },
};
